import { type BaseButtonProps, Button } from "../../button";
import { cn } from "../../utils";
import { DataTableInputWrapper } from "./data-table-input-wrapper";

/** Props Interface */
interface DataTableButtonProps
	extends Pick<
		BaseButtonProps,
		"children" | "isDisabled" | "isLoading" | "icon" | "variant" | "onClick"
	> {}

export function DataTableButton({ children, variant = "ghost", ...props }: DataTableButtonProps) {
	/** Render */
	return (
		<DataTableInputWrapper>
			<Button
				variant={variant}
				className={cn("w-full! h-full!", "rounded-none! text-sm! border-0! justify-start! gap-4!")}
				{...props}
			>
				{children}
			</Button>
		</DataTableInputWrapper>
	);
}
